import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: ".5",
  y: ".5",
  width: "17",
  height: "17",
  rx: "3.5",
  fill: "#F2F2F2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.313 9c0-.31.251-.563.562-.563h8.25a.562.562 0 1 1 0 1.126h-8.25A.563.563 0 0 1 4.312 9Z",
  fill: "#333"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 4.313c.31 0 .563.251.563.562v8.25a.562.562 0 1 1-1.126 0v-8.25c0-.31.252-.563.563-.563Z",
  fill: "#333"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: ".5",
  y: ".5",
  width: "17",
  height: "17",
  rx: "3.5",
  stroke: "#F2F2F2"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render };